import React, { useState, useContext, useEffect, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    Tooltip,
    ButtonGroup,
    TextField,
    InputAdornment
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';


import { AccountCircle, Add, AddBox, ArrowBack, ArrowForward, Cancel, Check, CheckBox, CheckBoxOutlineBlank, CleanHands, ClearAll, Delete, Download, Edit, Info, LibraryAddCheck, Message, PictureAsPdf, PlayArrow, QrCode, Search } from '@mui/icons-material';


import { globalstyles } from '../lib/definitions';
import { myFormat, myTimestampToDate, propComparatorDate, checkComponentPresence, getSelectedElement } from '../utils/ui_utils';
import { get_Cow_list } from '../FirebaseUtils/dbCow';
import { useEvent } from "../context/eventContext";
import { getCowLight } from '../definitions/cow';
import { PropertyButton, PropertyLabel } from '../definitions/property';
import { CategoryButton, CategoryLabel } from '../definitions/category';
import { PresenceButton, PresenceIcon } from '../components/PresenceButton';
import { CowtypeBadge } from '../components/CowtypeButton';

const PAGE_COUNT = 20

export const CowSublistAdvanceDialog = forwardRef(({ handleMoveCow, addCow }, ref) => {

    const { selEvent } = useEvent()
    const [open, setOpen] = useState(false);
    const [isEdited, setIsEdited] = useState(false)
    const [is_new, setIsNew] = useState(false)
    const [cow_list, setCowList] = useState([])
    const [cur_category, setCurCategory] = useState({})
    const [selected_cow_id, setSelectedCow] = useState([])
    const [element_list, setElementList] = useState([])
    const [filtered_element_list, setFilteredElementList] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [showSearch, setShowSearch] = useState(false)
    const [search_text, setSearchText] = useState('')
    const [view_list, setViewList] = useState({ last_index: -1, list: [], cur_page: 0 })


    useEffect(() => {
        if (search_text.length > 0) {
            setFilteredElementList(element_list.filter(c => (c.catalog_id && String(c.catalog_id).includes(search_text))
                || c.name.toLowerCase().includes(search_text)
                //    || c.serial.toLowerCase().includes(search_text)
            ))
        } else {
            setFilteredElementList(element_list)
        }

    }, [search_text])

    const goPrevPage = () => {
        setViewList(v => ({ ...v, cur_page: v.cur_page - 1 }))
    }

    const goNextPage = () => {
        setViewList(v => ({ ...v, cur_page: v.cur_page + 1 }))
    }

    useEffect(() => {
        let view_list = []
        console.log("DO SET VIEW", filtered_element_list.length)
        if (filtered_element_list.length > 0) {
            for (let i = 0; i < filtered_element_list.length; i += PAGE_COUNT) {
                const chunk = filtered_element_list.slice(i, i + PAGE_COUNT);
                view_list.push(chunk)
            }
        }
        setViewList({ list: view_list, cur_page: 0 })
        setIsLoading(false)
    }, [filtered_element_list])

    useEffect(() => {
        console.log("DO SET FILTER")
        setFilteredElementList(element_list)

    }, [element_list])



    useImperativeHandle(ref, () => {
        return {
            onOpen(el, i) {
                console.log("DO OPEN")
                setOpen(true);
                setIsNew(false)
                setCowList(el)
                setCurCategory(i)
                setSelectedCow([])
                setIsEdited(false)
                reloadFn()
            },
            onReload(el) {
                setCowList(el)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };

    const handleAdd = () => {
        addCow(selected_cow_id.map(c => getCowLight(getSelectedElement(c, element_list, 'id'))))
        setOpen(false)
    }

    const handleMove = () => {
        handleMoveCow(cow_list.filter(c => selected_cow_id.includes(c.id)), cur_category.id)

    }

    const toggleSelect = (cow_id) => {
        setSelectedCow(c => {
            let _c = [...c]
            const k = _c.indexOf(cow_id)
            if (k < 0) {
                _c.push(cow_id)
            } else {
                _c.splice(k, 1)
            }
            return _c
        })
    }


    const selectAll = () => {
        setSelectedCow(filtered_element_list.map(c => c.id))
    }

    const selectNone = () => {
        setSelectedCow([])
    }

    const reloadFn = async (el) => {
        setIsLoading(true)
        if (el) {
            setElementList(lst => {
                const c = checkComponentPresence(el, element_list, 'id')
                let _el = [...lst]
                if (c >= 0) {
                    _el.splice(c, 1, el)
                }
                return _el
            })


        } else {
            const data = await get_Cow_list(selEvent.id)
            const _sort_data = data.sort(propComparatorDate('birthdate', true, 'catalog_id'))
            _sort_data.reverse()
            setElementList(_sort_data)

        }
    }
    return (


        <Dialog open={open} onClose={handleClose} fullScreen={true}>
            <DialogTitle>
                Aggiungi soggetti {cur_category?.category_name} ({cow_list.length} soggetti già presenti)<br />
                <Box sx={{ fontSize: '0.7em' }}>{cur_category?.category_description}</Box>
                <Grid container>
                    <Grid size="grow">
                        <ButtonGroup size="small" color="light">
                            <Button onClick={selectNone} startIcon={<CheckBoxOutlineBlank />}></Button>
                            <Tooltip title="seleziona tutti gli elementi filtrati">
                                <Button onClick={() => selectAll(true)} startIcon={<CheckBox />}></Button>
                            </Tooltip>
                            <Box sx={{ fontSize: '0.7em', pl: 1 }}>
                                {selected_cow_id.length} selezionati
                            </Box>
                        </ButtonGroup>
                    </Grid>
                    <Grid size={"grow"} sx={{ textAlign: 'center' }}>
                        <ButtonGroup size="small">
                            <Button disabled={view_list.cur_page === 0} color="secondary" onClick={goPrevPage}><ArrowBack /></Button>
                            <Button >{view_list.cur_page + 1}/{view_list.list.length}</Button>
                            <Button disabled={view_list.cur_page === view_list.list.length - 1} color="secondary" onClick={goNextPage}><ArrowForward /></Button>
                        </ButtonGroup>
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="search_text"
                            type="search_text"
                            name="search_text"
                            size="small"
                            placeholder="cerca codice catalogo o nome"
                            autoComplete="search_text"
                            autoFocus
                            fullWidth
                            variant="outlined"
                            value={search_text}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search />
                                        </InputAdornment>
                                    ),
                                },
                            }}
                            onChange={(ev) => setSearchText(ev.target.value)}
                        />
                    </Grid>
                </Grid>
                {view_list.list[view_list.cur_page]?.length > 0 ?
                    <>
                        <Grid container sx={globalstyles.listHeader}>
                            <Grid size={0.5} >
                            </Grid>
                            <Grid size={0.5}>
                                catalogo
                            </Grid>
                            <Grid size={1}>
                                matricola
                            </Grid>
                            <Grid size="grow">
                                nome
                            </Grid>
                            <Grid size="grow">
                                proprietà <br />
                                <i>comproprietà</i>
                            </Grid>
                            <Grid size={0.5}>
                                età <br/>
                                (mesi)
                            </Grid>
                            <Grid size={0.5}>
                                parti<br/>
                                (ultimo parto)
                            </Grid>
                            <Grid size="grow">
                                Categoria
                            </Grid>
                            <Grid size={1}>
                            </Grid>

                        </Grid>

                    </>
                    :
                    <></>
                }
            </DialogTitle>
            <DialogContent>

                {view_list.list[view_list.cur_page]?.length > 0 ?
                    <>

                        <Grid >
                            {view_list.list[view_list.cur_page].map((cow, k) => (
                                <OneCow
                                    key={k}
                                    cow={cow}
                                    is_disabled={cow_list.map(c => c.id).includes(cow.id)}
                                    toggleSelect={toggleSelect}
                                    is_selected={selected_cow_id.includes(cow.id)}
                                    index={k + (PAGE_COUNT * view_list.cur_page)}
                                />
                            ))}
                        </Grid>
                    </>
                    :
                    <Grid >
                        {element_list.length === 0 ?
                            <>
                                Nessun soggetto ancora inserito
                            </>
                            :
                            <>
                                Nessun soggetto trovato con i filtri applicati
                            </>
                        }
                    </Grid>
                }
            </DialogContent>
            <DialogActions>
                <ButtonGroup>

                    <Button variant='outlined' key={'bc'} onClick={handleClose}>Chiudi</Button>
                    {selected_cow_id.length > 0 &&
                        <Button color="secondary" variant='contained' startIcon={<AddBox />} onClick={handleAdd}>Aggiungi {selected_cow_id.length} soggetto/i</Button>
                    }
                </ButtonGroup>
            </DialogActions>
        </Dialog>

    )

})



const OneCow = memo(({ cow, toggleSelect, is_selected, is_disabled }) => {

    return (
        <Grid container sx={{ ...globalstyles.list_row, ...globalstyles.elem_row, fontSize: '0.7em' }} >
            {toggleSelect &&
                <Grid size={0.5}>
                    <Button disabled={is_disabled} variant={is_selected ? 'contained' : 'outlined'} onClick={() => toggleSelect(cow.id)} size="small" >{is_selected ? <CheckBox  sx={{fontSize:'1em'}}/> : <CheckBoxOutlineBlank  sx={{fontSize:'1em'}}/>}</Button>
                </Grid>
            }
            <Grid size={0.5}>
                {cow.catalog_id}
            </Grid>
            <Grid size={1} flexDirection={"row"} container>
                <CowtypeBadge cow_type={cow.cow_type} />
                {cow.serial}
            </Grid>

            <Grid size={"grow"}>
                {cow.name}
            </Grid>
            <Grid size={"grow"}>
                {cow.property &&
                    <PropertyLabel element={cow.property} />
                }
                <Box sx={{ color: 'grey', fontStyle: 'italic' }}>{cow.coproperty}</Box>
            </Grid>
            <Grid size={"auto"}>
            </Grid>
            <Grid size={0.5}>
                {cow.birthdate && myFormat(cow.birthdate)}
            </Grid>
            <Grid size={0.5}>
                {cow.birth}
                {cow.birth > 0 && cow.last_birthdate &&
                    <>
                        &nbsp;({myFormat(cow.last_birthdate)})
                    </>
                }
            </Grid>
            <Grid size="grow">
                {cow.category &&
                    <CategoryLabel element={cow.category} />
                }

            </Grid>
            <Grid size={1}>
                <PresenceIcon is_present={cow.is_present} />
            </Grid>

        </Grid>
    )

})

